import React from 'react';

export const Back = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10.375 15.375H22.875C23.0408 15.375 23.1997 15.4408 23.3169 15.5581C23.4342 15.6753 23.5 15.8342 23.5 16C23.5 16.1658 23.4342 16.3247 23.3169 16.4419C23.1997 16.5592 23.0408 16.625 22.875 16.625H10.375C10.2092 16.625 10.0503 16.5592 9.93306 16.4419C9.81585 16.3247 9.75 16.1658 9.75 16C9.75 15.8342 9.81585 15.6753 9.93306 15.5581C10.0503 15.4408 10.2092 15.375 10.375 15.375Z"
                fill="#F5F5F5"
            />
            <path
                d="M10.6336 16L15.8174 21.1825C15.9348 21.2999 16.0007 21.459 16.0007 21.625C16.0007 21.791 15.9348 21.9501 15.8174 22.0675C15.7 22.1849 15.5409 22.2508 15.3749 22.2508C15.2089 22.2508 15.0498 22.1849 14.9324 22.0675L9.3074 16.4425C9.24919 16.3844 9.20301 16.3155 9.17151 16.2395C9.14 16.1636 9.12378 16.0822 9.12378 16C9.12378 15.9178 9.14 15.8364 9.17151 15.7605C9.20301 15.6845 9.24919 15.6156 9.3074 15.5575L14.9324 9.9325C15.0498 9.81514 15.2089 9.74921 15.3749 9.74921C15.5409 9.74921 15.7 9.81514 15.8174 9.9325C15.9348 10.0499 16.0007 10.209 16.0007 10.375C16.0007 10.541 15.9348 10.7001 15.8174 10.8175L10.6336 16Z"
                fill="#F5F5F5"
            />
        </svg>
    );
};
